module.exports = __webpack_public_path__ + "288397345fbff5146314fd66fe4d378f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NI.svg
// module id = lCvN
// module chunks = 0